export default __webpack_public_path__ + "static/media/style_white.159e4e54.svg";